import 'css-chunksrc/client/scenes/workloads/wbs/list/dateForm/dateTimeInput/styles.scss';export default {
  "dateTimeInput": "_dateTimeInput_1uhh2_1",
  "input": "_input_1uhh2_6",
  "placeholder": "_placeholder_1uhh2_22",
  "value": "_value_1uhh2_27",
  "calendarInput": "_calendarInput_1uhh2_32",
  "calendar": "_calendar_1uhh2_32",
  "timeList": "_timeList_1uhh2_48",
  "timeListWrapper": "_timeListWrapper_1uhh2_57",
  "time": "_time_1uhh2_48",
  "timeName": "_timeName_1uhh2_69",
  "invalid": "_invalid_1uhh2_75",
  "disabled": "_disabled_1uhh2_83"
};